// extracted by mini-css-extract-plugin
export default {"staffPicksBadge":"_1Dh5f6hU"};